import React from 'react';
import Card from '../../../components/base/Card';

const DirectContactSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#212026] dark:text-white mb-4">Direct Contact Information</h2>
          <p className="text-xl text-[#889d8f] dark:text-[#dbcfbf]">
            Prefer to contact us directly? Here are our communication channels.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Email */}
          <Card className="p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-[#e18033] rounded-full flex items-center justify-center mx-auto mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-[#212026] dark:text-white mb-3">Email Us</h3>
            <p className="text-[#889d8f] dark:text-[#dbcfbf] mb-4">Send us an email and we'll respond within 24 hours</p>
            <div className="space-y-2">
              <p className="text-[#e18033] font-semibold">info@digitalmediainnovations.com</p>
            </div>
          </Card>

          {/* Phone */}
          <Card className="p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-[#e18033] rounded-full flex items-center justify-center mx-auto mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-[#212026] dark:text-white mb-3">Call Us</h3>
            <p className="text-[#889d8f] dark:text-[#dbcfbf] mb-4">Speak directly with our design experts</p>
            <div className="space-y-2">
              <p className="text-[#e18033] font-semibold">+1.303.873.1100</p>
              <p className="text-sm text-[#889d8f] dark:text-[#dbcfbf]">Mon-Fri: 9AM-6PM MT</p>
            </div>
          </Card>

          {/* Office */}
          <Card className="p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-[#e18033] rounded-full flex items-center justify-center mx-auto mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-[#212026] dark:text-white mb-3">Visit Us</h3>
            <p className="text-[#889d8f] dark:text-[#dbcfbf] mb-4">Schedule an appointment to visit our studio</p>
            <div className="space-y-2">
              <p className="text-[#212026] dark:text-white font-medium">7108 S Alton Way, Suite H,</p>
              <p className="text-[#212026] dark:text-white font-medium">Centennial, CO 80112</p>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default DirectContactSection;
